module.exports = __webpack_public_path__ + "static/media/dashboard-fill.f6ce8c47.svg";